import script from "./SendWithBillingDetailSupport.vue?vue&type=script&setup=true&lang=js"
export * from "./SendWithBillingDetailSupport.vue?vue&type=script&setup=true&lang=js"

import "./SendWithBillingDetailSupport.vue?vue&type=style&index=0&id=b392aaf8&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b392aaf8"]])

export default __exports__